import React from 'react';
import { Frame, SageClassnames } from '@kajabi/sage-react';

import { useUiResourceContext, useResultContext } from 'common/components/CopyMagic/contexts';
import NullState from 'common/components/CopyMagic/components/NullState';
import FeedbackSentiment from 'common/components/CopyMagic/components/FeedbackSentiment';

import ContentInput from '../ContentInput';

const topFrameClassNames = [SageClassnames.SPACERS.SM_TOP, SageClassnames.SPACERS.SM_BOTTOM].join(
  ' ',
);

const ResultDisplay = () => {
  const { loading, error } = useUiResourceContext();
  const { result } = useResultContext();

  if (loading || error) return null;
  if (!result)
    return (
      <NullState
        helpArticleLinkText="Prompt suggestions"
        helpArticleLink="https://help.kajabi.com/hc/en-us/articles/12995207754779"
      />
    );

  return (
    <div>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        width={Frame.WIDTHS.FILL}
        className={topFrameClassNames}
      >
        <h3 className={`${SageClassnames.TYPE.BODY_SEMI}`}>Suggestion</h3>
        <FeedbackSentiment />
      </Frame>
      <ContentInput />
    </div>
  );
};

export default ResultDisplay;
